import {useParams} from "react-router";
import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {
  deleteTagValue,
  fetchTagValuesByService,
  getBluejayCommunicationChannelByServiceId as onGetBluejayCommunicationChannelByServiceId,
  getIntegrationKeys,
  getSpecificServices,
  postCreateIntegrationKey,
  postSetMaintenanceByServiceID,
  resetIntegrationUrl,
} from "../../store/service/actions";
import {useDispatch, useSelector} from "react-redux";
import {
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Popover,
  PopoverBody,
  Row,
  UncontrolledTooltip
} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {getIntegrationLogo, getIntegrationOptions, getLocalDateTime} from "../../helpers/component_helpers";
import Select from "react-select";
import {useFormik} from "formik";
import * as Yup from "yup";
import OnShowIntegrationActionUrlModal from "./OnShowIntegrationActionUrlModal";
import OnShowIntegrationUrlModal from "./OnShowIntegrationUrlModal";
import OnEditModal from "./OnEditModal";
import AddTagModal from "./AddTagModal";
import OnEditTagModal from "./OnEditTagModal";
import MaintenanceModal from "./MaintenanceModal";
import ConfirmationModal from "./ConfirmationModal";
import '../../pages/Service/services.scss';
import DocsTooltip from "components/Common/DocsTooltip";
import Switch from "react-switch";
import moment from "moment-timezone";

const ServiceDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const service_detail = useSelector((state) => state.Service.specific_service || []);
  const integrationKeys = useSelector((state) => state.Service.integrationKeys || []);
  const tagValues = useSelector((state) => state.Service.tagValues || []); // Added to get tag values
  const [selectedType, setSelectedType] = useState(null);
  const [integrationActionModal, setIntegrationActionModal] = useState(false);
  const [integrationKeyActionID, setIntegrationKeyActionID] = useState(null);
  const [serviceId, setServiceId] = useState(null);
  const [modal, setModal] = useState(false);
  const [modall, setModall] = useState(false);
  const [modalService, setModalService] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [modalAddTag, setModalAddTag] = useState(false);
  const [addTagModal, setAddTagModal] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [tagIdToDelete, setTagIdToDelete] = useState(null)
  const [localTagValues, setLocalTagValues] = useState(tagValues);
  const domain = window.location.hostname;
  const [isEditTagModalOpen, setEditTagModalOpen] = useState(false);
  const [maintenanceModal, setMaintenanceModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState({});
  const [popoverOpen1, setPopoverOpen1] = useState({});

  useEffect(() => {
    setLocalTagValues(tagValues);
  }, [tagValues]);
  const handleTagAdded = (newTag) => {
    setLocalTagValues((prevTags) => [...prevTags, newTag]);
  };
  const handleDeleteClick = (tagId) => {
    setTagIdToDelete(tagId);
    setConfirmationModalOpen(true);
  };
  const toggleTooltip = (key, isOpen) => {
    setPopoverOpen1(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };
  const confirmDelete = () => {
    dispatch(deleteTagValue({ tag_value_id: tagIdToDelete }));
    setLocalTagValues((prevTagValues) =>
      prevTagValues.filter((tag) => tag.id !== tagIdToDelete)
    );
    setConfirmationModalOpen(false);
  };
  const handleEditTag = (tag) => {
    setSelectedTag(tag);
    setEditTagModalOpen(true);
  };
  const handleTagUpdated = (updatedTag) => {
    const updatedTags = localTagValues.map((tag) =>
      tag.id === updatedTag.id ? updatedTag : tag
    );
    setLocalTagValues(updatedTags);
    setEditTagModalOpen(false);
  };
  const toggle = () => {
    if (modal) {
      setModal(false);
      setSelectedType(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }
  const togglee = () => {
    if (modall===true) {
      setModall(false);
    } else {
      setModall(true);
    }
  }
  const openModal = () => {
    toggle();
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      integrationType: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter the name"),
      integrationType: Yup.string(),
    }),
    onSubmit: async (values) => {
      if (integrationKeys.some((key) => key.name === values.name)) {
        validation.setFieldError('name', 'Integration key with this name already exists!');
      } else {
        try {
          await dispatch(postCreateIntegrationKey(id, values.name, values.integrationType));
        } catch (error) {
          console.error('Error:', error);
        } finally {
          openModal();
        }
      }
    }
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validation.isValid) {
      validation.handleSubmit(e);
    }
  };

  const communicationChannelsById = useSelector(state => state.Service.communication_channels_by_id || []);

  useEffect(() => {
    dispatch(getSpecificServices(id));
  }, [getSpecificServices]);

  useEffect(() => {
    dispatch(fetchTagValuesByService(id));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(getIntegrationKeys(id));
    // Cleanup function to reset integrationUrl when the component unmounts
    return () => {
      dispatch(resetIntegrationUrl());
    };
  }, [getIntegrationKeys]);

  const IntegrationActionToggle = (integrationKeyActionID) => {
    if (integrationActionModal) {
      setIntegrationKeyActionID(null);
      setIntegrationActionModal(false);
    } else {
      setIntegrationKeyActionID(integrationKeyActionID);
      setIntegrationActionModal(true);
    }
  }

  const openIntegrationActionURLModal = (integrationKeyActionID) => {
    IntegrationActionToggle(integrationKeyActionID);
  }

  function handleSelectIntegrationType(selectedValue) {
    setSelectedType(selectedValue);
    validation.setFieldValue('integrationType', selectedValue.value);
  }

  const optionIntegrationTypes = [
    {
      label: "Integration Type",
      options: getIntegrationOptions(),
    },
  ];

  const toggle_service = () => {
    if (modalService) {
      setServiceId(null);
      setModalService(false);
      setTimeout(() => {
        dispatch(getSpecificServices(id));
      }, 500);
    } else {
      setModalService(true);
    }
  }

  function toggleMaintenanceModal() {
    if (maintenanceModal) {
      setServiceId(null);
      setMaintenanceModal(false);
      setTimeout(() => {
        dispatch(getSpecificServices(id));
      }, 500);
    } else {
      setMaintenanceModal(true)
    }
  }

  const toggle_add_tag = () => {
    if (modalAddTag) {
      setModalAddTag(false);
      setServiceId(null);
    } else {
      setModalAddTag(true);
      setServiceId(service_detail?.id);
    }
  }
  const onEditService = (serviceIdx) => {
    setServiceId(serviceIdx);
    dispatch(getSpecificServices(id))
    toggle_service();
  };

  const onAddTag = (serviceIdx) => {
    setServiceId(serviceIdx);
    toggle_add_tag();
  }
  useEffect(() => {
    dispatch(onGetBluejayCommunicationChannelByServiceId(id));
  }, [id, onGetBluejayCommunicationChannelByServiceId]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      position:"absolute",
      background: '#382b42', // Background color of the dropdown menu
      zIndex: 999,
    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  function toggleMaintenance(currentServiceId) {
    const current_state = getMaintenanceState(service_detail?.maintenance_window_end)
    if (current_state) {
      const payload = {
        service_id: currentServiceId,
        duration_in_minutes: -1
      }
      dispatch(postSetMaintenanceByServiceID(payload))
      setServiceId(null);
      setTimeout(() => {
        dispatch(getSpecificServices(id));
      }, 500);
    } else {
      setServiceId(currentServiceId);
      toggleMaintenanceModal()
    }
  }

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  function getCurrentTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  // function getLocalTime(utcTime) {
  //   const timezone = getCurrentTimezone();
  //   const format = 'DD/MM/YYYY, h:mm:ss A';
  //   return moment(utcTime).tz(timezone).format(format);
  // }


  function getMaintenanceState(maintenanceEnd) {
    let currentTimeZone = getCurrentTimezone()
    const currentTime = moment().tz(currentTimeZone);
    const maintenanceEndMoment = moment(maintenanceEnd).tz(currentTimeZone)
    return currentTime.isBefore(maintenanceEndMoment);
  }

  return (
    <React.Fragment>
      <OnShowIntegrationActionUrlModal isOpen={integrationActionModal} toggle={IntegrationActionToggle} id={integrationKeyActionID} />
      <OnShowIntegrationUrlModal isOpen={modal} toggle={toggle} />
      <OnEditModal isOpen={modalService} serviceId={serviceId} toggle={toggle_service} />
      <AddTagModal isOpenn={modalAddTag} serviceId={serviceId} togglee={toggle_add_tag}  onTagAdded={handleTagAdded} />
      <OnEditTagModal
          isOpen={isEditTagModalOpen}
          toggle={() => setEditTagModalOpen(false)}
          tag={selectedTag}
          serviceId={id}
          onTagUpdated={handleTagUpdated}
        />
      <MaintenanceModal
        isOpen={maintenanceModal}
        toggle={toggleMaintenanceModal}
        serviceId={serviceId}
      />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="9">
            <div className="d-flex gap-1">
              <Breadcrumbs
                title={"Application Service Details"}
                breadcrumbItem={"Application Service Details"}
              />
              <span role="button" className="align-items-center" id='serviceTooltips'>
                <i className="bx bx-help-circle font-size-16 text-white"/>
              </span>
              <DocsTooltip
                placement={'right'}
                isOpen={tooltip}
                toggle={() => {setTooltip(!tooltip)}}
                targetId={'serviceTooltips'}
                multipleLinks={[
                  {
                    linkText: 'Map to Service',
                    link: 'https://docs.temperstack.com/temperstack/platform/auto-deploy/map-to-service'
                  },
                  {
                    linkText: 'Notification Integrations',
                    link: 'https://docs.temperstack.com/temperstack/platform/incident-command/integration-guide-for-alert-notifications'
                  }
              ]}
              />
            </div>

            </Col>
            <Col lg="3" className="d-flex align-items-center justify-content-end gap-3">
            <button className="btn btn-primary w-md" onClick={() => {onAddTag(service_detail?.id);}}>
                  Add Tag
                </button>
              <Link to={`/alert-log?serviceId=${id}`}>
                <button className="btn btn-primary w-md">
                  View Alerts
                </button>
              </Link>
            </Col>
          </Row>
          <Row>
            <Card zIndex="2">
              <div className="d-flex gap-4">
            <div className="w-50">
              <CardBody>
                <div className="table-responsive">
                  <table className="table-purple-org">
                    <tbody className="table-dark text-white">
                      <tr>
                        <td scope="row">Service Name</td>
                        <td>{service_detail?.name}</td>
                      </tr>
                      <tr>
                        <td scope="row">E-mail ID</td>
                        <td>
                          <div
                            id={`email_tooltip_${service_detail?.id}`}
                            style={{
                              display: 'inline-block',
                              maxWidth: '400px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                            onMouseEnter={() => toggleTooltip(service_detail?.id, true)}
                            onMouseLeave={() => toggleTooltip(service_detail?.id, false)}
                          >
                            {service_detail?.email_id?.length > 90 ? service_detail?.email_id.substring(0, 90) + "..." : service_detail?.email_id}
                          </div>
                          <Popover
                            placement="top"
                            isOpen={popoverOpen1[service_detail?.id] || false}
                            target={`email_tooltip_${service_detail?.id}`}
                            toggle={() => toggleTooltip(service_detail?.id, !popoverOpen1[service_detail?.id])}
                          >
                            <PopoverBody>{service_detail?.email_id}</PopoverBody>
                          </Popover>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">Slack Channel Name</td>
                        <td>{service_detail?.slack_channel_name}</td>
                      </tr>
                      {(domain === 'msteamtestaccount.temperstack.com' || domain === '10xengg.myapp.com' || domain.endsWith('temperstack.dev')) ? (
                        <tr>
                          <td>
                            <td scope="row" style={{ paddingRight: '5px' }}>MS Team:</td>
                            <td>{service_detail?.ms_team_channel?.name}</td>
                          </td>
                          <td>
                            <td scope="row" style={{ paddingRight: '5px' }}>MS Team Channel:</td>
                            <td>{service_detail?.ms_team_channel_name}</td>
                          </td>
                        </tr>
                      ) : null}
                      <tr>
                        <td scope="row">Temperstack On-Call Name</td>
                        <td>
                          <Link to={`/oncall-policies/${service_detail?.bluejay_oncall_policy?.id}`}
                            className="link-primary">
                            {service_detail?.bluejay_oncall_policy?.name}
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">Team</td>
                        <td>
                        {service_detail?.bluejay_team?.name}
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">Updated At</td>
                        <td>{getLocalDateTime(service_detail?.updated_at)}</td>
                      </tr>
                      <tr>
                        <td scope="row">Receive Notification On</td>
                        <td>
                          <ul>
                            {communicationChannelsById
                              .filter(channel => channel.enabled)
                              .map(channel => (
                                <li key={channel.id}>{channel.name}</li>
                              ))}
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Row className="mb-2">
                    <Col className="text-end">
                      <button className="btn btn-primary w-md" onClick={() => {
                        onEditService(service_detail?.id);
                      }}>
                        Edit Service
                      </button>
                    </Col>
                  </Row>
                </div>
              </CardBody>
              <CardBody>
                <CardTitle className="text-uppercase"><b>Maintenance</b></CardTitle>
                <table className="table-purple-org">
                  <tbody className="table-dark">
                  {getMaintenanceState(service_detail?.maintenance_window_end) &&
                    <tr>
                      <td className="w-50">Current Maintenance Window End</td>
                      <td className="w-50">
                        {getLocalDateTime(service_detail?.maintenance_window_end)}
                      </td>
                    </tr>
                  }
                  <tr>
                    <td className="w-50">Enable Maintenance</td>
                    <td style={{display: `flex`, alignItems: `center`}}>
                      <Switch
                        uncheckedIcon={<OffSymbol/>}
                        checkedIcon={<OnSymbol/>}
                        className="me-1 mb-sm-8"
                        height={20}
                        width={44}
                        onColor="#34c38f"
                        offColor="#f46a6a"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 5px"
                        onChange={(e) => toggleMaintenance(service_detail?.id)}
                        checked={getMaintenanceState(service_detail.maintenance_window_end)}
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>

                  </CardBody>
                </div>
                <div className="w-50">
              <CardBody>
                <CardTitle className="text-uppercase"><b>Create New Integration</b></CardTitle>
                <Form className="form-horizontal mt-4" onSubmit={handleFormSubmit}>
                  <div className="mb-3">
                    <Label className="form-label">Integration Name</Label>
                    <Input
                      name="name"
                      className="input"
                      placeholder="Name"
                      type="text"
                      required
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name || ""}
                      invalid={
                        validation.touched.name && validation.errors.name ? true : false
                      }
                    />
                    {validation.touched.name && validation.errors.name && (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label className="form-label">Integration Type</Label>
                    <Select
                      name="integrationType"
                      value={selectedType}
                      onChange={(selectedValue) => {
                        handleSelectIntegrationType(selectedValue);
                      }}
                      options={optionIntegrationTypes}
                      className="select"
                      required
                      styles={customStyles}
                    />
                  </div>
                  <Row className="mb-3">
                    <Col className="text-end">
                      <button className="btn btn-primary w-md" type="submit">
                        Create Key
                      </button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </div>
            </div>
            </Card>
          </Row>
          <Row>
            <Card zIndex="1">
              <CardHeader className="bg-transparent">
                <h5 className="my-2">Service Integration Keys</h5>
              </CardHeader>
              <div>
                <Col lg={12}>
                  <div className="header">
                    <div className="resources-header-card">
                      <Row className="align-items-center padding-t-10">
                        {
                          <React.Fragment>
                            <Col md="3">
                              <div className="mb-2 text-center">
                                Integration Name
                              </div>
                            </Col>
                            <Col md="3">
                              <div className="mb-2 text-center">
                                Integration Key
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2 text-center">
                                Integration Type
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Created At
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Last Used
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Updated At
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Actions
                              </div>
                            </Col>
                          </React.Fragment>
                        }
                      </Row>
                    </div>
                  </div>
                </Col>
                <div className="scrollable-container">
                  {integrationKeys?.map((integrationKey, index) => {
                    return (
                      <div className="header" key={index}>
                        <div className="resources-body-card">
                          <Row className="align-items-center padding-t-10">
                            <Col md="3">
                              <div className="mb-2 text-center">
                                {integrationKey?.name}
                              </div>
                            </Col>
                            <Col md="3">
                              <div className="mb-2 text-center">
                                {integrationKey?.key_display}
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2 text-center">
                                <img src={getIntegrationLogo(integrationKey?.integration_type)}
                                  alt={integrationKey?.integration_type}
                                  className="avatar-xs rounded-circle"
                                />
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                {getLocalDateTime(integrationKey?.created_at)}
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                {getLocalDateTime(integrationKey?.last_used_at)}
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                {getLocalDateTime(integrationKey?.updated_at)}
                              </div>
                            </Col>
                            <Col md="1" style={{ textAlign: 'center', alignContent: 'center', alignItems: 'center' }}>
                              <i
                                className="fa fa-eye me-2"
                                onClick={() => {
                                  if (integrationKey?.id) {
                                    openIntegrationActionURLModal(integrationKey?.id);
                                  }
                                }}
                                style={{ cursor: 'pointer' }}
                              ></i>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </Card>
          </Row>
          <Row>
            <Card zIndex="1" width='40%'>
              <CardHeader className="bg-transparent">
                <h5 className="my-2">Tags</h5>
              </CardHeader>
              <div>
                <Col lg={12}>
                  <div className="card-item" >
                    <div className="resources-header-card">
                      <Row className="align-items-center padding-t-10">
                        {
                          <React.Fragment>
                            <Col md="4">
                              <div className="mb-2 text-center">
                                Tag Name
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-2 text-center">
                                Tag Value
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-2 text-center">
                                Actions
                              </div>
                            </Col>
                          </React.Fragment>
                        }
                      </Row>
                    </div>
                  </div>
                </Col>
                <div className="scrollable-container">
                {localTagValues?.map((tag, index) => (
                  tag["key name"] && tag.value ? (
                    <div className="header" key={index}>
                      <div className="resources-body-card">
                        <Row className="align-items-center padding-t-10">
                          <Col md="4">
                            <div className="mb-2 text-center">{tag["key name"]}</div>
                          </Col>
                          <Col md="5">
                            <div className="mb-2 text-center">{tag.value}</div>
                          </Col>
                          <Col md="1">
                            <i className="mdi mdi-pencil font-size-18 text-success "
                               id={`edittooltip-${index}`} style={{ cursor: 'pointer' }} onClick={() => handleEditTag(tag)}/>
                            <UncontrolledTooltip placement="top" target={`edittooltip-${index}`} >
                              Edit
                            </UncontrolledTooltip>
                          </Col>
                          <Col md="2">
                            <i className="mdi mdi-trash-can font-size-18 text-danger"
                               id="deletetooltip" style={{ cursor: 'pointer' }}  onClick={() => handleDeleteClick(tag.id)} />
                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                Delete
                            </UncontrolledTooltip>
                          </Col>
                          <ConfirmationModal
                            isOpen={isConfirmationModalOpen}
                            toggle={() => setConfirmationModalOpen(!isConfirmationModalOpen)}
                            onConfirm={confirmDelete}
                          />
                        </Row>
                      </div>
                    </div>
                  ) : null
                ))}
                </div>
              </div>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default ServiceDetails;